import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/theme.css';
import './styles/contract-cards-fix.css';

// Import components
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import CompanyOnboarding from './components/auth/CompanyOnboarding';
import Dashboard from './components/dashboard/Dashboard';
import OverviewLanding from './components/dashboard/OverviewLanding';
import EnterpriseLayout from './components/layout/EnterpriseLayout';
import AssetManagement from './components/asset/AssetManagement';
import AssetEdit from './components/asset/AssetEdit';
import AssetView from './components/asset/AssetView';
import CreateAsset from './components/asset/CreateAsset';
import AssetsLanding from './components/asset/AssetsLanding';
import ContractsLanding from './components/contract/ContractsLanding';
import AILanding from './components/ai/AILanding';
import FinanceLanding from './components/finance/FinanceLanding';
import PaymentManagement from './components/finance/PaymentManagement';
import IntelligenceLanding from './components/intelligence/IntelligenceLanding';
import CollaborationLanding from './components/collaboration/CollaborationLanding';
import IntegrationLanding from './components/integration/IntegrationLanding';
import SystemLanding from './components/system/SystemLanding';
import ProjectsLanding from './components/project/ProjectsLanding';
import ProjectReportsLanding from './components/project/ProjectReportsLanding';
import ProjectDashboardReports from './components/project/ProjectDashboardReports';
import ProjectDashboardReportsWindow from './components/project/ProjectDashboardReportsWindow';
import ProjectDashboardReportsStandalone from './components/project/ProjectDashboardReportsStandalone';
import PerformanceReports from './components/project/reports/PerformanceReports';
import FinancialReports from './components/project/reports/FinancialReports';
import ResourceUtilizationReports from './components/project/reports/ResourceUtilizationReports';
import AnalyticsReports from './components/project/reports/AnalyticsReports';
import CustomReports from './components/project/reports/CustomReports';
import AutomatedReports from './components/project/reports/AutomatedReports';
import RiskAnalysisReports from './components/project/reports/RiskAnalysisReports';
import MilestoneReports from './components/project/reports/MilestoneReports';
import TeamPerformanceReports from './components/project/reports/TeamPerformanceReports';
import ProjectComplianceReports from './components/project/reports/ComplianceReports';
import ExecutiveSummaryReports from './components/project/reports/ExecutiveSummaryReports';
import ProjectManagement from './components/project/ProjectManagement';
import ProjectDashboard from './components/project/ProjectDashboard';
import CreateProject from './components/project/CreateProject';
import EditProject from './components/project/EditProject';
import ViewProject from './components/project/ViewProject';
import MilestoneTracking from './components/milestone/MilestoneTracking';
import CreateMilestone from './components/milestone/CreateMilestone';
import ViewMilestone from './components/milestone/ViewMilestone';
import EditMilestone from './components/milestone/EditMilestone';
import TaskManagement from './components/task/TaskManagement';
import CreateTask from './components/task/CreateTask';
import EditTask from './components/task/EditTask';
import ViewTask from './components/task/ViewTask';
import TeamCollaboration from './components/team/TeamCollaboration';
import CreateTeam from './components/team/CreateTeam';
import EditTeam from './components/team/EditTeam';
import ViewTeam from './components/team/ViewTeam';
import RiskManagement from './components/risk/RiskManagement';
import CreateRisk from './components/risk/CreateRisk';
import ViewRisk from './components/risk/ViewRisk';
import EditRisk from './components/risk/EditRisk';
import TimeTrackingLanding from './components/time/TimeTrackingLanding';
import TimeEntryManagement from './components/time/TimeEntryManagement';
import CreateTimeEntry from './components/time/CreateTimeEntry';
import ViewTimeEntry from './components/time/ViewTimeEntry';
import EditTimeEntry from './components/time/EditTimeEntry';
import Timesheets from './components/time/Timesheets';
import CreateTimesheet from './components/time/CreateTimesheet';
import EditTimesheet from './components/time/EditTimesheet';
import ViewTimesheet from './components/time/ViewTimesheet';
import Billing from './components/time/Billing';
import CreateInvoice from './components/time/CreateInvoice';
import EditInvoice from './components/time/EditInvoice';
import ViewInvoice from './components/time/ViewInvoice';
import Analytics from './components/time/Analytics';
import InsightsAnalytics from './components/insights/Analytics';
import TimeTrackingSettings from './components/time/TimeTrackingSettings';
import TimeTrackingReportsLanding from './components/time/TimeTrackingReportsLanding';
import TimeTrackingDashboardReport from './components/time/TimeTrackingDashboardReport';
import SubcontractingLanding from './components/subcontracting/SubcontractingLanding';
import SubcontractorManagement from './components/subcontracting/SubcontractorManagement';
import AddContractor from './components/subcontracting/AddContractor';
import ViewSubcontractor from './components/subcontracting/ViewSubcontractor';
import EditSubcontractor from './components/subcontracting/EditSubcontractor';
import WorkOrders from './components/subcontracting/WorkOrders';
import CreateWorkOrder from './components/subcontracting/CreateWorkOrder';
import ViewWorkOrder from './components/subcontracting/ViewWorkOrder';
import EditWorkOrder from './components/subcontracting/EditWorkOrder';
import VendorOnboarding from './components/subcontracting/VendorOnboarding';
import CreateVendorOnboarding from './components/subcontracting/CreateVendorOnboarding';
import ViewVendorOnboarding from './components/subcontracting/ViewVendorOnboarding';
import EditVendorOnboarding from './components/subcontracting/EditVendorOnboarding';
import PerformanceTracking from './components/subcontracting/PerformanceTracking';
import CreatePerformanceReview from './components/subcontracting/CreatePerformanceReview';
import ViewPerformanceReview from './components/subcontracting/ViewPerformanceReview';
import EditPerformanceReview from './components/subcontracting/EditPerformanceReview';
import ComplianceManagement from './components/subcontracting/ComplianceManagement';
import CreateComplianceRecord from './components/subcontracting/CreateComplianceRecord';
import ViewComplianceRecord from './components/subcontracting/ViewComplianceRecord';
import EditComplianceRecord from './components/subcontracting/EditComplianceRecord';
import BillingPayments from './components/subcontracting/BillingPayments';
import CreateBillingRecord from './components/subcontracting/CreateBillingRecord';
import ResourceAllocation from './components/subcontracting/ResourceAllocation';
import CreateResourceAllocation from './components/subcontracting/CreateResourceAllocation';
import ViewResourceAllocation from './components/subcontracting/ViewResourceAllocation';
import EditResourceAllocation from './components/subcontracting/EditResourceAllocation';
import ReportsAnalytics from './components/subcontracting/ReportsAnalytics';
import VendorManagement from './components/vendor/VendorManagement';
import CustomerManagement from './components/customer/CustomerManagement';
import ContractManagement from './components/contract/ContractManagement';
import ContractEdit from './components/contract/ContractEdit';
import ContractView from './components/contract/ContractView';
import LegalHold from './components/contract/LegalHold';
import ContractTypeView from './components/contract/ContractTypeView';
// import ContractTypeEdit from './components/contract/ContractTypeEdit';
import ContractLifecycle from './components/contract/ContractLifecycle';
import ContractTemplates from './components/contract/ContractTemplates';
import ESignature from './components/contract/ESignature';
import ESignatureEdit from './components/contract/ESignatureEdit';
import ComplianceTracking from './components/contract/ComplianceTracking';
import ObligationDashboard from './components/contract/ObligationDashboard';
import FrameworkList from './components/contract/FrameworkList';
import FrameworkForm from './components/contract/FrameworkForm';
import FrameworkRequirements from './components/contract/FrameworkRequirements';
import AddRequirement from './components/contract/AddRequirement';
import ContractTypeManagement from './components/contract/ContractTypeManagement';
import CreateContractType from './components/contract/CreateContractType';
import ContractAnalytics from './components/contract/ContractAnalytics';
import ContractRenewalsAlerts from './components/contract/ContractRenewalsAlerts';
import FixedPriceContract from './components/contract/FixedPriceContract';
import TimeMaterialsContract from './components/contract/TimeMaterialsContract';
import CreateTimeMaterialsContract from './components/contract/CreateTimeMaterialsContract';
import EnhancedFixedPriceContract from './components/contract/EnhancedFixedPriceContract';
import EnhancedTimeMaterialsContract from './components/contract/EnhancedTimeMaterialsContract';
import ContractTypeConfiguration from './components/contract/ContractTypeConfiguration';
import ContractCardsDemo from './components/contract/ContractCardsDemo';
import AIInsights from './components/ai/AIInsights';
import AIContractDrafting from './components/ai/AIContractDrafting';
import AISearchQA from './components/ai/AISearchQA';
import PredictiveAnalytics from './components/ai/PredictiveAnalytics';
import DocumentIngestion from './components/ai/DocumentIngestion';
import ClauseRiskScoring from './components/ai/ClauseRiskScoring';
import VoiceToContract from './components/ai/VoiceToContract';
import MultilingualTranslation from './components/ai/MultilingualTranslation';
import AINegotiationSupport from './components/ai/AINegotiationSupport';
import AIChatAssistant from './components/ai/AIChatAssistant';
import AskCAM360 from './components/ai/AskCAM360';
import SmartSuggestions from './components/ai/SmartSuggestions';
import ChatHistory from './components/ai/ChatHistory';
import ChatSettings from './components/ai/ChatSettings';
import AssetFinance from './components/finance/AssetFinance';
import ContractFinance from './components/finance/ContractFinance';
import GlobalHelpCenter from './components/help/GlobalHelpCenter';
import CAM360HelpCenter from './components/help/CAM360HelpCenter';
import HelpFileViewer from './components/help/HelpFileViewer';
import InvoiceValidation from './components/finance/InvoiceValidation';
import CashFlowForecasting from './components/finance/CashFlowForecasting';
import SpendOptimization from './components/finance/SpendOptimization';
import RiskExposure from './components/finance/RiskExposure';
import MultiCurrency from './components/finance/MultiCurrency';
import BudgetingForecasting from './components/finance/BudgetingForecasting';
import CreateBudgetPlan from './components/finance/CreateBudgetPlan';
import ForecastAnalysis from './components/finance/ForecastAnalysis';
import BudgetVsActuals from './components/finance/BudgetVsActuals';
import BudgetReports from './components/finance/BudgetReports';
import WorkflowManagement from './components/workflow/WorkflowManagement';
import VisualWorkflowBuilder from './components/workflow/VisualWorkflowBuilder';
import ApprovalRulesSetup from './components/workflow/ApprovalRulesSetup';
import WorkflowTemplates from './components/workflow/WorkflowTemplates';
import WorkflowReports from './components/workflow/WorkflowReports';
import NotificationCenter from './components/notifications/NotificationCenter';
import NotificationRenewalAlerts from './components/notifications/RenewalAlerts';
import MaintenanceAlerts from './components/notifications/MaintenanceAlerts';
import ComplianceAlerts from './components/notifications/ComplianceAlerts';
import SystemAlerts from './components/notifications/SystemAlerts';
import NotificationSettings from './components/notifications/NotificationSettings';
import Dashboards from './components/insights/Dashboards';
import AssetROIReports from './components/insights/AssetROIReports';
import ContractValueReports from './components/insights/ContractValueReports';
import UserManagement from './components/system/UserManagement';
import RoleManagement from './components/system/RoleManagement';
import Settings from './components/system/Settings';
import MobileAppAccess from './components/system/MobileAppAccess';
import PWAConfiguration from './components/system/PWAConfiguration';
import DeviceRegistration from './components/system/DeviceRegistration';
import OfflineModeSettings from './components/system/OfflineModeSettings';
import MasterDataManagement from './components/settings/MasterDataManagement';
import ClauseLibrary from './components/settings/ClauseLibrary';
import SystemMonitoring from './components/system/SystemMonitoring';
import ERPIntegration from './components/integration/ERPIntegration';
import ProcurementIntegration from './components/integration/ProcurementIntegration';
import CRMIntegration from './components/integration/CRMIntegration';
import SSOIntegration from './components/integration/SSOIntegration';
import APIManagement from './components/integration/APIManagement';
import CollaborationHub from './components/collaboration/CollaborationHub';
import VersionControl from './components/collaboration/VersionControl';
import AuditTrails from './components/collaboration/AuditTrails';
import AccessControls from './components/collaboration/AccessControls';
import ComplianceReports from './components/collaboration/ComplianceReports';
import DocumentLibrary from './components/collaboration/DocumentLibrary';
import UploadDocument from './components/collaboration/UploadDocument';
import SearchTagDocuments from './components/collaboration/SearchTagDocuments';
import VersionHistory from './components/collaboration/VersionHistory';
import DocumentReports from './components/collaboration/DocumentReports';
import AssignmentUsage from './components/assets/AssignmentUsage';
import FinancialValuation from './components/assets/FinancialValuation';
import AssetLifecycle from './components/assets/AssetLifecycle';
import AssetCategorization from './components/assets/AssetCategorization';
import MaintenanceOperations from './components/maintenance/MaintenanceOperations';
import Reports from './components/insights/Reports';
import DataTableDemo from './components/common/DataTableDemo';
import UserTest from './components/test/UserTest';
import DirectAPITest from './components/test/DirectAPITest';
import AuthTest from './components/test/AuthTest';
import Support from './components/support/Support';
import SourcingLanding from './components/sourcing/SourcingLanding';
import RfpManagement from './components/sourcing/RfpManagement'
import CreateRfp from './components/sourcing/CreateRfp';
import EditRfp from './components/sourcing/EditRfp';
import ViewRfp from './components/sourcing/ViewRfp';
import VendorResponseManagement from './components/sourcing/VendorResponses';
import AddResponse from './components/sourcing/AddResponse';
import BidEvaluation from './components/sourcing/BidEvaluation';
import ViewVendorBid from './components/sourcing/ViewVendorBid';
import AwardManagement from './components/sourcing/AwardManagement';
import PreContractLanding from './components/precontract/precontractLanding';
import PreContractPolicies from './components/precontract/precontractpolicies';
import CreatePolicy from './components/precontract/createPolicy';
import DoAMatrix from './components/precontract/DoAMatrix';
import CreateDoA from './components/precontract/CreateDoA';
import ViewDoA from './components/precontract/ViewDoA';
import DueDiligenceConfig from './components/precontract/DueDiligenceConfig';
import ComplianceLogs from './components/precontract/ComplianceLogs';
import BillingDashboard from './components/finance/BillingDashboard';
import DoAManagement from './components/precontract/doaManagement';
import DoAFormModal from './components/precontract/doaFormModal';

// Import context
import { AuthProvider, useAuth } from './context/AuthContext';
import { AssetProvider } from './context/AssetContext';
import { HelpProvider } from './context/HelpContext';
import { AIProvider } from './context/AIContext';

// Import help components
import GlobalHelp from './components/help/GlobalHelp';
import PageHelp from './components/help/PageHelp';
import StandaloneHelp from './components/help/StandaloneHelp';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: 'var(--secondary-color)',
        }}
      >
        <div
          style={{
            textAlign: 'center',
            padding: 'var(--spacing-xl)',
            backgroundColor: 'var(--white)',
            borderRadius: 'var(--border-radius-lg)',
            boxShadow: 'var(--shadow-lg)',
          }}
        >
          <div
            style={{
              width: '40px',
              height: '40px',
              border: '4px solid var(--accent-color)',
              borderTop: '4px solid var(--primary-color)',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto var(--spacing-md)',
            }}
          />
          <p style={{ color: 'var(--text-secondary)', margin: 0 }}>
            Loading...
          </p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Main App Routes
const AppRoutes = () => {
  // Small redirect helpers to preserve params/search when migrating old paths
  const RedirectPMEdit = () => {
    const { id } = useParams();
    const { search } = useLocation();
    return <Navigate to={`/projects/edit/${id}${search}`} replace />;
  };

  const RedirectPMView = () => {
    const { id } = useParams();
    const { search } = useLocation();
    return <Navigate to={`/projects/view/${id}${search}`} replace />;
  };

  const RedirectPMBase = () => {
    const { search } = useLocation();
    return <Navigate to={`/projects/management${search}`} replace />;
  };

  const RedirectPMCreate = () => {
    const { search } = useLocation();
    return <Navigate to={`/projects/create${search}`} replace />;
  };

  const RedirectMilestoneBase = () => {
    const { search } = useLocation();
    return <Navigate to={`/milestones${search}`} replace />;
  };

  const RedirectMilestoneCreate = () => {
    const { search } = useLocation();
    return <Navigate to={`/milestones/create${search}`} replace />;
  };

  const RedirectTaskBase = () => {
    const { search } = useLocation();
    return <Navigate to={`/tasks/management${search}`} replace />;
  };

  const RedirectTaskCreate = () => {
    const { search } = useLocation();
    return <Navigate to={`/tasks/create${search}`} replace />;
  };

  const RedirectTaskEdit = () => {
    const { id } = useParams();
    const { search } = useLocation();
    return <Navigate to={`/tasks/edit/${id}${search}`} replace />;
  };

  const RedirectTaskView = () => {
    const { id } = useParams();
    const { search } = useLocation();
    return <Navigate to={`/tasks/view/${id}${search}`} replace />;
  };

  const RedirectTeamBase = () => {
    const { search } = useLocation();
    return <Navigate to={`/team/management${search}`} replace />;
  };

  const RedirectTeamCreate = () => {
    const { search } = useLocation();
    return <Navigate to={`/team/create${search}`} replace />;
  };

  const RedirectTeamEdit = () => {
    const { id } = useParams();
    const { search } = useLocation();
    return <Navigate to={`/team/edit/${id}${search}`} replace />;
  };

  const RedirectTeamView = () => {
    const { id } = useParams();
    const { search } = useLocation();
    return <Navigate to={`/team/view/${id}${search}`} replace />;
  };

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/onboard" element={<CompanyOnboarding />} />
      <Route path="/help" element={<CAM360HelpCenter />} />
      <Route path="/help/:helpFile" element={<HelpFileViewer />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <EnterpriseLayout>
              <Routes>
                <Route path="/" element={<Navigate to="/overview" replace />} />
                <Route path="/overview" element={<OverviewLanding />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/sourcing" element={<SourcingLanding />} />
                  <Route path="/sourcing/rfps" element={<RfpManagement />} />
                  <Route path="/sourcing/rfps/edit/:id" element={<EditRfp />} />
                  <Route path="/sourcing/rfps/view/:id" element={<ViewRfp />} />
                  <Route path="/sourcing/rfps/create" element={<CreateRfp />} />
                  <Route path="/sourcing/responses" element={<VendorResponseManagement />} />
                  <Route path="/sourcing/responses/add/:rfpId" element={<AddResponse />} />
                  <Route path="/sourcing/bid-evaluation" element={<BidEvaluation />} />
                  <Route path="/sourcing/responses/view/:id" element={<ViewVendorBid />} />
                  <Route path="/sourcing/awards" element={<AwardManagement />} />
                <Route path="/assets" element={<AssetsLanding />} />
                <Route
                  path="/assets/management"
                  element={<AssetManagement />}
                />
                <Route path="/assets/create" element={<CreateAsset />} />
                <Route path="/assets/edit/:id" element={<AssetEdit />} />
                <Route path="/assets/view/:id" element={<AssetView />} />
                <Route path="/contracts" element={<ContractsLanding />} />
                <Route
                  path="/contracts/management"
                  element={<ContractManagement />}
                />
                <Route path="/ai" element={<AILanding />} />
                <Route path="/finance" element={<FinanceLanding />} />
                <Route path="/finance/payments" element={<PaymentManagement />} />
                <Route path="/intelligence" element={<IntelligenceLanding />} />
                <Route
                  path="/collaboration"
                  element={<CollaborationLanding />}
                />
                <Route path="/integration" element={<IntegrationLanding />} />
        <Route path="/projects" element={<ProjectsLanding />} />
        {/* Backwards-compatible redirects for old project paths */}
        <Route path="/projects/project-management" element={<RedirectPMBase />} />
        <Route path="/projects/project-management/create" element={<RedirectPMCreate />} />
        <Route path="/projects/project-management/edit/:id" element={<RedirectPMEdit />} />
        <Route path="/projects/project-management/view/:id" element={<RedirectPMView />} />

        <Route path="/projects/milestone-tracking" element={<RedirectMilestoneBase />} />
        <Route path="/projects/milestone-tracking/create" element={<RedirectMilestoneCreate />} />

        <Route path="/projects/task-management" element={<RedirectTaskBase />} />
        <Route path="/projects/task-management/create" element={<RedirectTaskCreate />} />
        <Route path="/projects/task-management/edit/:id" element={<RedirectTaskEdit />} />
        <Route path="/projects/task-management/view/:id" element={<RedirectTaskView />} />

        <Route path="/projects/team-collaboration" element={<RedirectTeamBase />} />
        <Route path="/projects/team-collaboration/create" element={<RedirectTeamCreate />} />
        <Route path="/projects/team-collaboration/edit/:id" element={<RedirectTeamEdit />} />
        <Route path="/projects/team-collaboration/view/:id" element={<RedirectTeamView />} />
        <Route path="/projects/reports" element={<ProjectReportsLanding />} />
        <Route path="/reports/project-dashboard" element={<ProjectDashboardReports />} />
        <Route path="/reports/project-dashboard-window" element={<ProjectDashboardReportsWindow />} />
        <Route path="/reports/project-dashboard-standalone" element={<ProjectDashboardReportsStandalone />} />
        <Route path="/reports/performance" element={<PerformanceReports />} />
        <Route path="/reports/financial" element={<FinancialReports />} />
        <Route path="/reports/resource-utilization" element={<ResourceUtilizationReports />} />
        <Route path="/reports/analytics" element={<AnalyticsReports />} />
        <Route path="/reports/custom" element={<CustomReports />} />
        <Route path="/reports/automated" element={<AutomatedReports />} />
        <Route path="/reports/risk-analysis" element={<RiskAnalysisReports />} />
        <Route path="/reports/milestones" element={<MilestoneReports />} />
        <Route path="/reports/team-performance" element={<TeamPerformanceReports />} />
        <Route path="/reports/compliance" element={<ProjectComplianceReports />} />
        <Route path="/reports/executive-summary" element={<ExecutiveSummaryReports />} />
        <Route path="/projects/dashboard" element={<ProjectDashboard />} />
        <Route path="/projects/management" element={<ProjectManagement />} />
        <Route path="/projects/create" element={<CreateProject />} />
        <Route path="/projects/edit/:id" element={<EditProject />} />
        <Route path="/projects/view/:id" element={<ViewProject />} />
        <Route path="/projects/:projectId/milestones/create" element={<CreateMilestone />} />
        <Route path="/projects/milestones/create" element={<CreateMilestone />} />
        <Route path="/projects/:projectId/milestones/:milestoneId/edit" element={<EditMilestone />} />
        <Route path="/projects/risks" element={<RiskManagement />} />
        <Route path="/risks/create" element={<CreateRisk />} />
        <Route path="/projects/time-tracking" element={<TimeTrackingLanding />} />
        <Route path="/projects/time-tracking/entry" element={<TimeEntryManagement />} />
        <Route path="/projects/time-tracking/entry/create" element={<CreateTimeEntry />} />
        <Route path="/projects/time-tracking/entry/view/:id" element={<ViewTimeEntry />} />
        <Route path="/projects/time-tracking/entry/edit/:id" element={<EditTimeEntry />} />
        <Route path="/projects/time-tracking/timesheets" element={<Timesheets />} />
        <Route path="/projects/time-tracking/timesheets/create" element={<CreateTimesheet />} />
        <Route path="/projects/time-tracking/timesheets/view/:id" element={<ViewTimesheet />} />
        <Route path="/projects/time-tracking/timesheets/edit/:id" element={<EditTimesheet />} />
        <Route path="/projects/time-tracking/billing" element={<Billing />} />
        <Route path="/projects/time-tracking/billing/create" element={<CreateInvoice />} />
        <Route path="/projects/time-tracking/billing/view/:id" element={<ViewInvoice />} />
        <Route path="/projects/time-tracking/billing/edit/:id" element={<EditInvoice />} />
                       <Route path="/projects/time-tracking/analytics" element={<Analytics />} />
                       <Route path="/projects/time-tracking/settings" element={<TimeTrackingSettings />} />
                       <Route path="/projects/time-tracking/reports" element={<TimeTrackingReportsLanding />} />
                       <Route path="/projects/time-tracking/reports/dashboard" element={<TimeTrackingDashboardReport />} />
        <Route path="/subcontracting" element={<SubcontractingLanding />} />
        <Route path="/subcontracting/management" element={<SubcontractorManagement />} />
        <Route path="/subcontracting/management/create" element={<AddContractor />} />
        <Route path="/subcontracting/management/view/:id" element={<ViewSubcontractor />} />
        <Route path="/subcontracting/management/edit/:id" element={<EditSubcontractor />} />
        <Route path="/subcontracting/work-orders" element={<WorkOrders />} />
        <Route path="/subcontracting/work-orders/create" element={<CreateWorkOrder />} />
        <Route path="/subcontracting/work-orders/view/:id" element={<ViewWorkOrder />} />
        <Route path="/subcontracting/work-orders/edit/:id" element={<EditWorkOrder />} />
        <Route path="/subcontracting/onboarding" element={<VendorOnboarding />} />
        <Route path="/subcontracting/onboarding/create" element={<CreateVendorOnboarding />} />
        <Route path="/subcontracting/onboarding/view/:id" element={<ViewVendorOnboarding />} />
        <Route path="/subcontracting/onboarding/edit/:id" element={<EditVendorOnboarding />} />
        <Route path="/subcontracting/performance" element={<PerformanceTracking />} />
        <Route path="/subcontracting/performance/create" element={<CreatePerformanceReview />} />
        <Route path="/subcontracting/performance/view/:id" element={<ViewPerformanceReview />} />
        <Route path="/subcontracting/performance/edit/:id" element={<EditPerformanceReview />} />
        <Route path="/subcontracting/compliance" element={<ComplianceManagement />} />
        <Route path="/subcontracting/compliance/create" element={<CreateComplianceRecord />} />
        <Route path="/subcontracting/compliance/view/:id" element={<ViewComplianceRecord />} />
        <Route path="/subcontracting/compliance/edit/:id" element={<EditComplianceRecord />} />
        <Route path="/subcontracting/billing" element={<BillingPayments />} />
        <Route path="/subcontracting/billing/create" element={<CreateBillingRecord />} />
        <Route path="/subcontracting/resources" element={<ResourceAllocation />} />
        <Route path="/subcontracting/resources/create" element={<CreateResourceAllocation />} />
        <Route path="/subcontracting/resources/view/:id" element={<ViewResourceAllocation />} />
        <Route path="/subcontracting/resources/edit/:id" element={<EditResourceAllocation />} />
        <Route path="/subcontracting/reports" element={<ReportsAnalytics />} />
        <Route path="/milestones" element={<MilestoneTracking />} />
        <Route path="/milestones/create" element={<CreateMilestone />} />
        <Route path="/milestones/edit/:id" element={<EditMilestone />} />
        <Route path="/projects/tasks" element={<Navigate to="/tasks/management" replace />} />
        <Route path="/tasks/management" element={<TaskManagement />} />
        <Route path="/tasks/create" element={<CreateTask />} />
        <Route path="/tasks/edit/:id" element={<EditTask />} />
        <Route path="/tasks/view/:id" element={<ViewTask />} />
        <Route path="/team/management" element={<TeamCollaboration />} />
        <Route path="/team/create" element={<CreateTeam />} />
        <Route path="/team/edit/:id" element={<EditTeam />} />
        <Route path="/team/view/:id" element={<ViewTeam />} />
                <Route path="/system" element={<SystemLanding />} />
                <Route path="/vendors" element={<VendorManagement />} />
                <Route path="/customers" element={<CustomerManagement />} />
                <Route
                  path="/contracts/edit/:contractId"
                  element={<ContractEdit />}
                />
                <Route
                  path="/contracts/view/:contractId"
                  element={<ContractView />}
                />
                <Route 
                  path="/contracts/legal-hold" 
                  element={<LegalHold />} 
                />
                <Route
                  path="/contracts/lifecycle"
                  element={<ContractLifecycle />}
                />
                <Route
                  path="/contracts/templates"
                  element={<ContractTemplates />}
                />
                <Route path="/contracts/e-signature" element={<ESignature />} />
                <Route
                  path="/contracts/e-signature/edit/:documentId"
                  element={<ESignatureEdit />}
                />
                <Route
                  path="/contracts/compliance"
                  element={<ComplianceTracking />}
                />
                <Route 
                  path="/contracts/obligations" 
                  element={<ObligationDashboard />} 
                />
                <Route 
                  path="/contracts/frameworks" 
                  element={<FrameworkList />} 
                />
                <Route 
                  path="/contracts/frameworks/new" 
                  element={<FrameworkForm />} 
                />
                <Route 
                  path="/contracts/frameworks/edit/:id" 
                  element={<FrameworkForm />} 
                />
                <Route 
                  path="/contracts/frameworks/:id/requirements" 
                  element={<FrameworkRequirements />} 
                />
                <Route 
                  path="/contracts/frameworks/:id/requirements/add" 
                  element={<AddRequirement />} 
                />
                <Route
                  path="/contracts/types/management"
                  element={<ContractTypeManagement />}
                />
                <Route
                  path="/contracts/types/create"
                  element={<CreateContractType />}
                />
                <Route
                  path="/contracts/types/view/:id"
                  element={<ContractTypeView />}
                />
                <Route
                  path="/contracts/analytics"
                  element={<ContractAnalytics />}
                />
                <Route
                  path="/contracts/renewals-alerts"
                  element={<ContractRenewalsAlerts />}
                />
                <Route
                  path="/contracts/fixed-price"
                  element={<FixedPriceContract />}
                />
                <Route
                  path="/contracts/time-materials"
                  element={<TimeMaterialsContract />}
                />
                <Route
                  path="/contracts/pre-contract"
                  element={<PreContractLanding />}
                />
                <Route 
                  path="/contracts/pre-contract/policies"
                  element={<PreContractPolicies />}
                />
                <Route
                  path="/contracts/pre-contract/policies/create"
                  element={<CreatePolicy />}
                />
                <Route 
                  path="/contracts/pre-contract/policies/edit/:id" 
                  element={<CreatePolicy />} 
                />
                <Route 
                  path="/contracts/pre-contract/policies/view/:id" 
                  element={<CreatePolicy />} 
                />
                <Route 
                  path="/contracts/pre-contract/doa" 
                  element={<DoAMatrix />} 
                />
                <Route 
                  path="/contracts/pre-contract/doa/create" 
                  element={<CreateDoA />} 
                />
                <Route 
                  path="/contracts/pre-contract/doa/view/:id" 
                  element={<ViewDoA />} 
                />
                <Route 
                  path="/contracts/pre-contract/doa/edit/:id" 
                  element={<CreateDoA />} 
                />
                <Route 
                  path="/contracts/pre-contract/due-diligence/config" 
                  element={<DueDiligenceConfig />} 
                />
                <Route 
                  path="/contracts/pre-contract/check-results" 
                  element={<ComplianceLogs />} 
                />
                <Route
                  path="/contracts/pre-contract/logs"
                  element={<ComplianceLogs />}
                />
                <Route
                  path="/contracts/pre-contract"
                  element={<PreContractLanding />}
                />
                <Route 
                  path="/contracts/pre-contract/policies"
                  element={<PreContractPolicies />}
                />
                <Route
                  path="/contracts/pre-contract/policies/create"
                  element={<CreatePolicy />}
                />
                <Route
                  path="/contracts/pre-contract/doa-management"
                  element={<DoAManagement/>}
                />
                <Route
                  path="/contracts/pre-contract/doa-form"
                  element={<DoAFormModal/>}
                />
                <Route
                  path="/contracts/time-materials/create"
                  element={<CreateTimeMaterialsContract />}
                />
                <Route
                  path="/contracts/fixed-price-enhanced"
                  element={<EnhancedFixedPriceContract />}
                />
                <Route
                  path="/contracts/time-materials-enhanced"
                  element={<EnhancedTimeMaterialsContract />}
                />
                <Route
                  path="/contracts/types/configure/:id"
                  element={<ContractTypeConfiguration />}
                />
                <Route
                  path="/contracts/cards-demo"
                  element={<ContractCardsDemo />}
                />
                <Route path="/ai/insights" element={<AIInsights />} />
                <Route path="/ai/drafting" element={<AIContractDrafting />} />
                <Route path="/ai/search" element={<AISearchQA />} />
                <Route path="/ai/analytics" element={<PredictiveAnalytics />} />
                <Route path="/ai/ingestion" element={<DocumentIngestion />} />
                <Route
                  path="/ai/risk-scoring"
                  element={<ClauseRiskScoring />}
                />
                <Route
                  path="/ai/voice-contract"
                  element={<VoiceToContract />}
                />
                <Route
                  path="/ai/translation"
                  element={<MultilingualTranslation />}
                />
                <Route
                  path="/ai/negotiation"
                  element={<AINegotiationSupport />}
                />
                <Route
                  path="/ai/chat-assistant"
                  element={<AIChatAssistant />}
                />
                <Route path="/ai/chat-assistant/ask" element={<AskCAM360 />} />
                <Route
                  path="/ai/chat-assistant/suggestions"
                  element={<SmartSuggestions />}
                />
                <Route
                  path="/ai/chat-assistant/history"
                  element={<ChatHistory />}
                />
                <Route
                  path="/ai/chat-assistant/settings"
                  element={<ChatSettings />}
                />
                <Route path="/finance/assets" element={<AssetFinance />} />
                <Route
                  path="/finance/contracts"
                  element={<ContractFinance />}
                />
                <Route
                  path="/finance/billing-dashboard"
                  element={<BillingDashboard />}
                />
                <Route
                  path="/finance/invoices"
                  element={<InvoiceValidation />}
                />
                <Route
                  path="/finance/cashflow"
                  element={<CashFlowForecasting />}
                />
                <Route
                  path="/finance/optimization"
                  element={<SpendOptimization />}
                />
                <Route path="/finance/risk" element={<RiskExposure />} />
                <Route path="/finance/currency" element={<MultiCurrency />} />
                <Route
                  path="/finance/budgeting"
                  element={<BudgetingForecasting />}
                />
                <Route
                  path="/finance/budgeting/create"
                  element={<CreateBudgetPlan />}
                />
                <Route
                  path="/finance/budgeting/forecast"
                  element={<ForecastAnalysis />}
                />
                <Route
                  path="/finance/budgeting/variance"
                  element={<BudgetVsActuals />}
                />
                <Route
                  path="/finance/budgeting/reports"
                  element={<BudgetReports />}
                />
                <Route
                  path="/workflow/management"
                  element={<WorkflowManagement />}
                />
                <Route
                  path="/workflow/builder"
                  element={<VisualWorkflowBuilder />}
                />
                <Route
                  path="/workflow/rules"
                  element={<ApprovalRulesSetup />}
                />
                <Route
                  path="/workflow/templates"
                  element={<WorkflowTemplates />}
                />
                <Route path="/workflow/reports" element={<WorkflowReports />} />
                <Route
                  path="/notifications/center"
                  element={<NotificationCenter />}
                />
                <Route
                  path="/notifications/renewals"
                  element={<NotificationRenewalAlerts />}
                />
                <Route
                  path="/notifications/maintenance"
                  element={<MaintenanceAlerts />}
                />
                <Route
                  path="/notifications/compliance"
                  element={<ComplianceAlerts />}
                />
                <Route
                  path="/notifications/system"
                  element={<SystemAlerts />}
                />
                <Route
                  path="/notifications/settings"
                  element={<NotificationSettings />}
                />
                <Route path="/insights/dashboards" element={<Dashboards />} />
                <Route
                  path="/insights/analytics"
                  element={<InsightsAnalytics />}
                />
                <Route
                  path="/insights/assetroi"
                  element={<AssetROIReports />}
                />
                <Route
                  path="/insights/contractvalue"
                  element={<ContractValueReports />}
                />
                <Route path="/system/users" element={<UserManagement />} />
                <Route path="/system/roles" element={<RoleManagement />} />
                <Route
                  path="/system/monitoring"
                  element={<SystemMonitoring />}
                />
                <Route
                  path="/system/master-data"
                  element={<MasterDataManagement />}
                />
                <Route
                  path="/system/clause-library"
                  element={<ClauseLibrary />}
                />
                <Route path="/integration/erp" element={<ERPIntegration />} />
                <Route
                  path="/integration/procurement"
                  element={<ProcurementIntegration />}
                />
                <Route path="/integration/crm" element={<CRMIntegration />} />
                <Route path="/integration/sso" element={<SSOIntegration />} />
                <Route path="/integration/api" element={<APIManagement />} />
                <Route
                  path="/collaboration/hub"
                  element={<CollaborationHub />}
                />
                <Route
                  path="/collaboration/versioning"
                  element={<VersionControl />}
                />
                <Route path="/collaboration/audit" element={<AuditTrails />} />
                <Route
                  path="/collaboration/access"
                  element={<AccessControls />}
                />
                <Route
                  path="/collaboration/compliance"
                  element={<ComplianceReports />}
                />
                <Route
                  path="/collaboration/documents"
                  element={<DocumentLibrary />}
                />
                <Route
                  path="/collaboration/documents/upload"
                  element={<UploadDocument />}
                />
                <Route
                  path="/collaboration/documents/search"
                  element={<SearchTagDocuments />}
                />
                <Route
                  path="/collaboration/documents/history"
                  element={<VersionHistory />}
                />
                <Route
                  path="/collaboration/documents/reports"
                  element={<DocumentReports />}
                />
                <Route
                  path="/assets/assignment"
                  element={<AssignmentUsage />}
                />
                <Route
                  path="/assets/financial"
                  element={<FinancialValuation />}
                />
                <Route path="/assets/lifecycle" element={<AssetLifecycle />} />
                <Route
                  path="/assets/categorization"
                  element={<AssetCategorization />}
                />
                <Route
                  path="/assets/maintenance"
                  element={<MaintenanceOperations />}
                />
                <Route path="/insights/reports" element={<Reports />} />
                <Route path="/system/settings" element={<Settings />} />
                <Route path="/system/mobile" element={<MobileAppAccess />} />
                <Route
                  path="/system/mobile/pwa"
                  element={<PWAConfiguration />}
                />
                <Route
                  path="/system/mobile/devices"
                  element={<DeviceRegistration />}
                />
                <Route
                  path="/system/mobile/offline"
                  element={<OfflineModeSettings />}
                />
                <Route path="/table-demo" element={<DataTableDemo />} />
                <Route path="/test/users" element={<UserTest />} />
                <Route path="/test/api" element={<DirectAPITest />} />
                <Route path="/test/auth" element={<AuthTest />} />
                <Route path="/support" element={<Support />} />
              </Routes>
            </EnterpriseLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <AssetProvider>
        <HelpProvider>
          <AIProvider>
            <Router>
              <div className="App">
                <AppRoutes />
                <GlobalHelp />
                <PageHelp />
              </div>
            </Router>
          </AIProvider>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </HelpProvider>
      </AssetProvider>
    </AuthProvider>
  );
}

export default App;